export enum ContractStatusCodes {
    Active = 'ACT',
    Expired = 'EXP',
    Cancelled = 'CAN',
    Terminated = 'TRM',
    Draft = 'DFT'
}

export type ContractStatusCode = ContractStatusCodes;
